export default "__VITE_ASSET__NHMZ_0F5__"